<template lang="html">
  <v-container fluid>
    <v-row v-if="showBreakingNews">
      <v-col cols="12">
        <v-card color="#bdd358" elevation="10">
          <v-card-title class="text-h4 font-weight-bold">
            BREAKING NEWS
          </v-card-title>
          <v-card-text>
            <div v-html="breakingNews">
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6" lg="3">
        <NumberCard title="Staked Percentage" more="/staking" :help="help1" color="#07D3DA">{{ stakedPercentage | toInt(2, "%")}}</NumberCard>
      </v-col>
      <v-col cols="12" md="6" lg="3">
        <NumberCard title="Daily Net Pos Buys" more="/price" :help="help2" color="#C6362F">{{ dailyNetPosBuys | toInt(0, "ETH")}}</NumberCard>
      </v-col>
      <v-col cols="12" md="6" lg="3">
        <NumberCard title="Price Floor Percentage" more="/price" :help="help3" color="#BDD358">{{ priceFloorPercentage | toInt(2, "%")}}</NumberCard>
      </v-col>
      <v-col cols="12" md="6" lg="3">
        <NumberCard title="Average Stake Length" more="/staking" :help="help4" color="#E28413">{{ averageStakeLength | toInt(2, "Days") }}</NumberCard>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="6" lg="4">
        <ChartCard title="WISE Supply" more="/supply">
          <apexchart width="100%" :options="chartoptions_supply" :series="chartseries_supply" height="330"></apexchart>
        </ChartCard>
      </v-col>
      <v-col cols="12" md="6" lg="4">
        <ChartCard title="Upcoming Stake Ends (7 Days)" more="/staking">
          <apexchart width="100%" type="bar" :options="chartoptions_stakeends" :series="chartseries_stakeends"></apexchart>
        </ChartCard>
      </v-col>
      <v-col cols="12" md="6" lg="4">
        <ChartCard title="News" more="/news">
          <NewsWidget mode="widget"></NewsWidget>
        </ChartCard>
      </v-col>

      <v-col cols="12" md="6" lg="4">
        <ChartCard title="Daily Penalties" more="/penalties">
          <apexchart ref="penaltiesChart" width="100%" type="bar" :options="chartoptions_penalties" :series="chartseries_penalties"></apexchart>
        </ChartCard>
      </v-col>

      <v-col cols="12" md="6" lg="4">
        <ChartCard title="Share Price (coming soon)" more="">
          <div class="text-center align-center my-10">
          <v-icon x-large class="text-center">
            mdi-clock-time-four-outline
          </v-icon>
          </div>
          <!-- <apexchart width="100%" type="line" :options="chartoptions1" :series="chartseries1"></apexchart> -->
        </ChartCard>
      </v-col>
      <v-col cols="12" md="6" lg="4" fill-height align="center">
        <ChartCard title="" more="/price" class="pt-3">
          <!-- <div class="nomics-ticker-widget" data-name="Wise" data-base="WISE" data-quote="ETH" data-size="responsive" data-theme="light"></div> -->
          <div class="nomics-ticker-widget" data-name="Wise" data-base="WISE" data-quote="ETH" data-size="responsive" :data-theme="getNomicsTheme()"></div>
        </ChartCard>
      </v-col>
    </v-row>
    <!-- <v-row>
      <v-col cols="4" >
        <RoiCard>
          <template v-slot:currency>
            USD
          </template>
          <template v-slot:factor>
            {{ factorUSD | toInt(2, "") }}x
          </template>
        </RoiCard>
      </v-col>
      <v-col cols="4" >
        <RoiCard>
          <template v-slot:currency>
            ETH
          </template>
          <template v-slot:factor>
            {{ factorETH | toInt(2, "") }}x
          </template>
        </RoiCard>
      </v-col>
    </v-row> -->
    <!-- <v-row>
      <v-col cols="12" md="6" lg="3">
        <NumberCard title="ROI on ETH" color="#E28413">{{ factorETH | toInt(2, "x")}}</NumberCard>
      </v-col>
      <v-col cols="12" md="6" lg="3">
        <RoiCard>
          <template v-slot:currency>
              ETH
            </template>
          <template v-slot:factor>
              {{ factorETH | toInt(2, "") }}x
            </template>
        </RoiCard>
      </v-col>
      <v-col cols="12" md="6" lg="3">
        <RoiCard>
          <template v-slot:currency>
              USD
            </template>
          <template v-slot:factor>
              {{ factorUSD | toInt(2, "") }}x
            </template>
        </RoiCard>
      </v-col>
    </v-row> -->
  </v-container>

</template>

<script>
// import RoiCard from "@/components/widgets/RoiCard.vue"
  import NumberCard from "@/components/widgets/NumberCard.vue"
  import ChartCard from "@/components/widgets/ChartCard.vue"
  import NewsWidget from "@/components/NewsWidget.vue"

  import {
    mapState
  } from 'vuex';

  import axios from "axios";

  import {
    apiUrl
  } from "../utils/dataPoller";

  export default {
    components: {
      // RoiCard,
      NumberCard,
      ChartCard,
      NewsWidget,
    },
    data() {
      return {
        showBreakingNews: false,
        breakingNews: "Wise lending released! Check <a href='https://wiselending.io'>WISE LENDING</a>",
        help1: "Uniswap liquidity not included",
        help2: "",
        help3: "Price decline until the price floor is reached. The price on Uniswap can't go lower with the current staking percentage and the current Uniswap liquidity.",
        help4: "Weighted average stake length",
        stakedPercentage: 0,
        dailyNetPosBuys: 0,
        priceFloorPercentage: 0,
        averageStakeLength: 0,
        currentPriceUSD: 0,
        currentPriceETH: 0,
        // factorUSD: 0,
        // factorETH: 0,
        initialETH: 55900.80344143941383017,
        initialWISE: 260760440.016238701274314313,
        initialPriceETH: 55900.80344143941383017 / 260760440.016238701274314313,
        initialPriceUSD: 55900.80344143941383017 / 260760440.016238701274314313 * 747.35,
        chartoptions_stakeends: {
          xaxis: {
            labels: {
              show: false
            },
            categories: [],
            axisBorder: {
              show: false
            },
            axisTicks: {
              show: false,
            },
          },
          grid: {
            show: false
          },
          dataLabels: {
            enabled: false,
            formatter: function(val) {
              return val.toFixed(0) + " WISE";
            },
            offsetY: -20,
            style: {
              fontSize: '12px',
              colors: ["#304758"]
            }
          },
          yaxis: {
            axisBorder: {
              show: false
            },
            axisTicks: {
              show: false,
            },
            labels: {
              show: false,
              formatter: function(val) {
                return (val / 1000).toFixed(0) + "K WISE";
              }
            }
          },
        },
        chartseries_stakeends: [{
          name: 'Stakes to end',
          data: []
        }],
        chartoptions_penalties: {
          chart: {
            type: 'bar'
          },
          xaxis: {
            labels: {
              show: false
            },
            categories: [],
            axisBorder: {
              show: false
            },
            axisTicks: {
              show: false,
            },
          },
          grid: {
            show: false
          },
          dataLabels: {
            enabled: false,
            formatter: function(val) {
              return val.toFixed(0) + " WISE";
            },
            offsetY: -20,
            style: {
              fontSize: '12px',
              colors: ["#304758"]
            }
          },
          yaxis: {
            axisBorder: {
              show: false
            },
            axisTicks: {
              show: false,
            },
            labels: {
              show: false,
              formatter: function(val) {
                return (val / 1000).toFixed(0) + "K WISE";
              }
            }
          },
        },
        chartseries_penalties: [{
          name: 'Daily Penalties',
          data: []
        }],
        chartoptions_supply: {
          chart: {
            type: 'donut',
          },
          stroke: {
            width: 0
          },
          dataLabels: {
            enabled: true,
            formatter(val, opts) {
              const name = opts.w.globals.labels[opts.seriesIndex]
              return [name, val.toFixed(2) + '%']
            }
          },
          fill: {
            type: 'solid',
          },
          tooltip: {
            enabled: true,
            y: {
              show: true,
              formatter: function(value) {
                return value.toFixed(0) + ' WISE'
              }
            },
          },
          plotOptions: {
            pie: {
              expandOnClick: false,
              dataLabels: {
                offset: 2,
                minAngleToShowLabel: 10
              },
              donut: {
                size: "60%",
                dataLabels: {
                  offset: -10
                },
                labels: {
                  show: true,
                  offsetX: 0,
                  offsetY: 50,
                  name: {
                    fontSize: '25px',
                    fontFamily: 'Montserrat, Roboto, sans-serif',
                    fontWeight: 400,
                    color: undefined,
                    offsetY: -10,
                    formatter: function(val) {
                      return val;
                    }
                  },

                  value: {
                    show: true,
                    fontSize: '12px',
                    fontFamily: 'Montserrat, Roboto, sans-serif',
                    fontWeight: 400,
                    color: undefined,
                    offsetY: 0,
                    formatter: function(val) {
                      return parseFloat(val).toFixed(0) + " WISE"
                    }
                  },
                  total: {
                    show: true,
                    showAlways: false,
                    label: 'Total',
                    fontSize: '18px',
                    fontFamily: 'Montserrat, Roboto, sans-serif',
                    fontWeight: 900,
                    color: '#373d3f',
                    formatter: function(w) {
                      return w.globals.seriesTotals.reduce((a, b) => {
                        return (a + b)
                      }, 0).toFixed(0) + " WISE"
                    }
                  }
                },
              }
            }
          },
          legend: {
            position: 'left',
            offsetY: 50,
            show: false,
            onItemClick: {
              toggleDataSeries: true
            },
            onItemHover: {
              highlightDataSeries: false
            },
          },
          labels: ['Staked', 'Wallet'],
          responsive: [{
            breakpoint: 480,
            options: {
              chart: {
                width: 200
              },
              legend: {
                position: 'left'
              }
            }
          }]
        },
        chartseries_supply: []
      }
    },
    computed: {
      ...mapState({
        currentUniswapStats: state => state.currentUniswapStats,
        currentETHPrice: state => state.currentETHPrice,
        totalStaked: state => state.totalStaked,
        totalSupply: state => state.totalSupply,
        uniswapBalance: state => state.uniswapBalance,
        currentWiseDay: state => state.currentWiseDay,
        stakeStats: state => state.stakeStats,
        allPenalties: state => state.allPenalties,
      }),
    },
    created() {
      let nomicsWidgetScript = document.createElement('script');
      // let coinpaprikaWidgetScript = document.createElement('script');
      // let coingeckoWidgetScript = document.createElement('script');
      // let coingeckoWidgetScript2 = document.createElement('script');
      nomicsWidgetScript.setAttribute('src', 'https://widget.nomics.com/embed.js')
      // coinpaprikaWidgetScript.setAttribute('src', 'https://unpkg.com/@coinpaprika/widget-currency/dist/widget.min.js')
      // coingeckoWidgetScript.setAttribute('src', 'https://widgets.coingecko.com/coingecko-coin-price-chart-widget.js')
      // coingeckoWidgetScript2.setAttribute('src', 'https://widgets.coingecko.com/coingecko-coin-compare-chart-widget.js')
      document.head.appendChild(nomicsWidgetScript);
      // document.head.appendChild(coinpaprikaWidgetScript);
      // document.head.appendChild(coingeckoWidgetScript);
      // document.head.appendChild(coingeckoWidgetScript2);

      // let nomicsWidgetScript = document.createElement('script');

      this.updateMarketData();
      this.updateAllCards();
      this.generateGraphs();
      // this.getRoiFactors();

    },
    methods: {
      getNomicsTheme() {
        return this.$vuetify.theme.dark ? "dark" : "light";
      },
      isDataFetched() {
        return (
          this.$store.state.currentETHPrice > -1 &&
          this.$store.state.currentUniswapStats.priceETH > -1
        );
      },
      generateGraphs() {
        this.generateSupplyGraph();
        this.generatePenaltiesGraph();
        this.generateStakeEndsGraph();
      },
      generateSupplyGraph() {
        let totalStaked = this.$store.state.totalStaked;
        let totalLiquid = this.$store.state.totalSupply - this.$store.state.uniswapBalance;

        this.chartseries_supply = [totalStaked, totalLiquid];
      },
      generatePenaltiesGraph() {

        let allPenalties = this.$store.state.allPenalties;
        if (allPenalties.length == 0) return;

        let startDay = 51;
        let daysArray = Array.from({
          length: this.$store.state.currentWiseDay - startDay + 1
        }, (_, i) => "Day " + (i + startDay));

        // this.$refs.penaltiesChart.updateSeries([{
        //   data: allPenalties,
        // }], false, true);

        this.chartseries_penalties = [{
          data: allPenalties
        }];
        this.chartoptions_penalties = {
          ...this.chartoptions_penalties,
          ...{
            xaxis: {
              labels: {
                show: false
              },
              categories: daysArray,
              axisBorder: {
                show: false
              },
              axisTicks: {
                show: false,
              },
            },
          },
        };

      },
      async generateStakeEndsGraph() {

        if (this.$store.state.currentWiseDay < 51) return;

        // let url_stakestarts = "https://wiseinfo.io/api_alpha/stakestarts_byenddayrange"
        // let url_stakends = "https://wiseinfo.io/api_alpha/stakeends_stakeids"
        let url_stakestarts = apiUrl + "/stakestarts_byenddayrange"
        let url_stakends = apiUrl + "/stakeends_stakeids"

        let parameters = {
          params: {
            endDayFrom: this.$store.state.currentWiseDay,
            endDayTo: this.$store.state.currentWiseDay + 7 - 1,
          }
        };
        let stakesMap = new Map();
        let stakeStarts = await axios.get(url_stakestarts, parameters);
        let stakeEnds = await axios.get(url_stakends, parameters);
        let stakeEndsArray = stakeEnds.data.map(stakeEnd => stakeEnd.stakeId);

        // initialize map with all days and 0
        for (let i = parameters.params.endDayFrom; i <= parameters.params.endDayTo; i++) {
          stakesMap.set(i, 0);
        }

        for (let stakeStart of stakeStarts.data) {
          let stakeId = stakeStart.stakeId;
          if (!stakeEndsArray.includes(stakeId)) {
            let endDay = stakeStart.endDay;
            let stakedAmount = stakeStart.stakedAmount;
            let currentDayValue = stakesMap.get(endDay);
            // stakesMap.set("Day " + endDay, currentDayValue + stakedAmount);
            stakesMap.set(endDay, currentDayValue + stakedAmount);
          }
        }

        // this.chartOptions.xAxis[0].categories = Array.from(stakesMap.keys());
        // this.chartOptions.series[0].data = Array.from(stakesMap.values());

        // this.chartseries_stakeends = [{
        //   data: Array.from(stakesMap.keys())
        // }];
        this.chartseries_stakeends = [{
          data: Array.from(stakesMap.values())
        }];
        this.chartoptions_stakeends = {
          xaxis: {
            categories: Array.from(stakesMap.keys()).map(day => "Day " + day)
          }
        }


      },
      updateAllCards() {
        this.updateCard1();
        this.updateCard2();
        this.updateCard3();
        this.updateCard4();
      },
      isDataFetchedCard1() {
        return (
          this.$store.state.totalStaked > -1 &&
          this.$store.state.totalSupply > -1 &&
          this.$store.state.uniswapBalance > -1
        )
      },
      isDataFetchedCard2() {
        return (
          this.$store.state.currentUniswapStats.tokensETH > -1 &&
          this.$store.state.currentWiseDay > -1
        )
      },
      isDataFetchedCard3() {
        return (
          this.$store.state.currentUniswapStats.tokensWISE > -1 &&
          this.$store.state.totalSupply > -1 &&
          this.$store.state.uniswapBalance > -1
        )
      },
      isDataFetchedCard4() {
        return (
          this.$store.state.stakeStats.weightedAverageStakeLength > -1
        )
      },
      updateCard1() {
        if (this.isDataFetchedCard1()) {
          let totalStaked = this.$store.state.totalStaked;
          let totalLiquid = this.$store.state.totalSupply - this.$store.state.uniswapBalance;
          this.stakedPercentage = totalStaked / (totalStaked + totalLiquid) * 100;
        }
      },
      updateCard2() {
        if (this.isDataFetchedCard2()) {
          let netPosBuysETH = this.$store.state.currentUniswapStats.tokensETH - this.initialETH;
          let stakingDays = this.$store.state.currentWiseDay - 51;
          this.dailyNetPosBuys = netPosBuysETH / stakingDays;
        }
      },
      updateCard3() {
        if (this.isDataFetchedCard3()) {
          let uniswapWISE = parseFloat(this.$store.state.currentUniswapStats.tokensWISE);
          let liquidWISE = parseFloat(this.$store.state.totalSupply - this.$store.state.uniswapBalance);
          let percentage = uniswapWISE ** 2 / (uniswapWISE + liquidWISE) ** 2;
          this.priceFloorPercentage = (percentage - 1) * 100;
        }
      },
      updateCard4() {
        if (this.isDataFetchedCard4()) {
          this.averageStakeLength = this.$store.state.stakeStats.weightedAverageStakeLength;
        }
      },
      updateMarketData() {
        if (this.isDataFetched()) {
          this.currentPriceETH = this.$store.state.currentUniswapStats.priceETH;
          this.currentPriceUSD = this.$store.state.currentETHPrice * this.$store.state.currentUniswapStats.priceETH;
        }
      },
    },
    watch: {
      currentUniswapStats() {
        this.updateMarketData();
        this.updateCard2();
        this.updateCard3();
        // this.getRoiFactors();
      },
      currentETHPrice() {
        this.updateMarketData();
        // this.getRoiFactors();
      },
      totalStaked() {
        this.updateCard1();
        this.generateGraphs();
      },
      totalSupply() {
        this.updateCard1();
        this.updateCard3();
        this.generateGraphs();
      },
      uniswapBalance() {
        this.updateCard1();
        this.updateCard3();
        this.generateGraphs();
      },
      currentWiseDay() {
        this.updateCard2();
      },
      stakeStats() {
        this.updateCard4();
      },
      allPenalties() {
        this.generatePenaltiesGraph();
      }
    }
  }
</script>

<style lang="css">
</style>
